// extracted by mini-css-extract-plugin
export default {"group":"VolumeGroup_group__p9AlY","volumeTitle":"VolumeGroup_volumeTitle__zNfDc","items":"VolumeGroup_items__rliUr"};